// import { PATIENT_DATA } from "../../mocks/mock-patient-data";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ToastController } from "ionic-angular";
import { Observable } from "rxjs/Observable";
// import { PatientData } from "../components/brief-bar/patient-data";
import HeaderData from "../../mocks/mock-header-data";
import { NAV_BAR_CONFIG, NAV_STATUS } from "../../mocks/mock-navigation";
import { ConfigurationService } from "../../providers/configuration/configuration.service";

@Injectable()
export class NavigationDataService {
  dataUrl: string;

  constructor(
    public httpClient: HttpClient,
    public toastCtrl: ToastController,
    private configurationService: ConfigurationService,
    private headerData: HeaderData
  ) {
    this.dataUrl = this.configurationService.getConfig().apiUrl;

    // console.log( "Set data URL in nav data: ", this.dataUrl );
  }

  loadHeaderData(): HeaderData {
    return this.headerData;
  }

  loadNavigationConfig(assessmentId: string): Observable<object> {
    let url = this.dataUrl + "/visits/" + assessmentId + "/template/navigation";

    return new Observable((observer) => {
      if (assessmentId !== undefined) {
        this.httpClient.get(url).subscribe(
          (data) => {
            // console.log("Nav data: ", data);
            let template = data["tmplJson"]
              ? JSON.parse(data["tmplJson"]["value"])
              : null;
            // console.log( "Got template: ", template );

            let assessmentType = template["title"];
            // console.log( "Determined assessment type:" ,assessmentType );

            let sections = template["assessmentSections"];
            // console.log( "Sections:", sections );

            sessionStorage.setItem("timeZone", "");
            if (data["additionalInformation"][0]) {
              sessionStorage.setItem(
                "timeZone",
                data["additionalInformation"][0]["timezone"]
              );
            }

            let nav = [];
            if (sections) {
              for (let item of sections) {
                // TODO: Clean this up once template names are aligned.....
                // TODO: vvvvvvvvvvvvvvvvvvvvvvv
                if (item.name == "brief") {
                  continue;
                } //These don't exist
                if (item.name == "risk") {
                  continue;
                } //These don't exist

                // TODO: ^^^^^^^^^^^^^^^^^^^^^^^
                // TODO: Clean this up once template names are aligned.....
                nav.push({
                  id: item.name,
                  sectionLookupCode: item.sectionId,
                  title: item.name,
                  icon: item.name + ".svg",
                  sortOrder: item.sort_order,
                });
              }
            }

            nav.sort((a, b): number => {
              if (a.sortOrder < b.sortOrder) {
                return -1;
              }
              if (a.sortOrder > b.sortOrder) {
                return 1;
              }

              return 0;
            });

            // console.log( "Generated nav: ", nav );
            observer.next({ type: assessmentType, navData: nav });
            observer.complete();
          },
          (err) => {}
        );
      } else {
        observer.next(NAV_BAR_CONFIG);
        observer.complete();
      }
    });
  }

  loadNavigationStatus(assessmentId: string): Observable<object> {
    let url = this.dataUrl + "/visits/" + assessmentId;

    return new Observable((observer) => {
      if (assessmentId !== undefined) {
        this.httpClient.get(url).subscribe(
          (data) => {
            // Cache the response immediately in the service, before notifying observers
            // This ensures caching happens even if component is destroyed
            const storageKey = `navStatus_${assessmentId}`;
            let status = data["assessmentSectionStatusValues"]
              ? data["assessmentSectionStatusValues"]
              : {};

            for (let element in status) {
              status[element] = JSON.parse(status[element]);
            }

            sessionStorage.setItem(storageKey, JSON.stringify(status));

            observer.next(data);
            observer.complete();
          },
          (err) => {
            observer.error(err);
            observer.complete();
          }
        );
      } else {
        observer.next(NAV_STATUS);
        observer.complete();
      }
    });
  }

  loadPatientData(chartId: string): Observable<object> {
    let url = this.dataUrl + "/patients/" + chartId + "/profiles";

    // console.log( "Data url for patient data: ", url );

    return new Observable((observer) => {
      this.httpClient.get(url).subscribe(
        (data) => {
          // console.log("Patient data: ", data);
          observer.next(data);
          observer.complete();
        },
        (err) => {
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  loadPatientDataObserable(chartId: string) {
    const url = this.dataUrl + "/patients/" + chartId + "/profiles";
    return this.httpClient.get(url);
  }

  presentErrorToast(err: HttpErrorResponse, message: string) {
    if (err && (err as any).code === "REFRESH_TOKEN_FAILED") {
      return;
    }
    message += " ";
    if (err.error instanceof Error) {
      // console.log( "Client side error: ", err.error );
      message += "Client error.";
    } else {
      if (err.status == 401) {
        message += "User not authorized.";
      } else if (err.status >= 500) {
        message += "Server error.";
      } else {
        message += "Communication error.";
      }
    }

    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: "below",
      cssClass: "error",
    });

    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/navigation/services/navigation-data.service.ts